import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  makeStyles,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { LinearProgressBar } from "../../shared";
import { getRequest } from "../../services/ApiServices";
import { FilterComponentObj } from "../FilterComponents/FilterComponentObj";
import { getCurrentDate, getCurrentDateOfBelow, getDefaultFuelDate, getDefaultLubeDate, getDefaultTotDate } from "../../services/DateServices";

export default function ReportFormat(props) {
  const { row, type, filterReportFual, filterReportLube, filterReportTot, DataName, isEmpty, tab, reportsubType, progressbarFlag } = props;
  let FormData = props.formObj
  let linearData = [];
  let max = 0;
  if (row.typeOfCase) {
    row.typeOfCase.forEach((item) => {
      max = item.value > max ? item.value : max;
    });
    row.typeOfCase.forEach((item) => {
      let data = { ...item };
      data.perValue = (item.value > 0 ? (item.value / (max)) * 100 : 0);
      linearData.push(data);
    });
  }
  const useStyles = makeStyles((theme) => ({
    mainBox: {},
    roundBox: {
      borderRadius: "50%",
      border: "6px solid #1a1a31",
      height: "130px",
      width: "130px",
      minWidth: "130px",
      textAlign: "center",
    },
  }));

  const classes = useStyles();
  const [formObj, setFormObj] = useState(FilterComponentObj);
  const [filtercomObj, setfiltercomObj] = React.useState(FilterComponentObj);
  const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
  const [selected, setSelected] = React.useState("")
  const onChangeText = (event) => {
    debugger;
    let Obj = {};
    let Obj_1 = {};
    let Obj_2 = {};
    let Obj_3 = {};
    if (reportsubType == "Fuel") {
      setSelected(event.title)
      Obj.Fqtreportenddate = [getDefaultFuelDate().endDate];
      Obj.Fqtreportstartdate = [getDefaultFuelDate().startDate];
      Obj_1 = [{ id: event.title, name: event.title }]
      
      filterReportFual({ Fqtreportstartdate: Obj.Fqtreportstartdate, Fqtreportenddate: Obj.Fqtreportenddate, ...props.formObj, Fqtreportstatus: Obj_1, })
    } else if (reportsubType == "Lube") {
      setSelected(event.title)
      Obj.lubereportenddate = [getDefaultLubeDate().endDate];
      Obj.lubereportstartdate = [getDefaultLubeDate().startDate];
      Obj_2 = [{ id: event.title, name: event.title }]
      filterReportLube({ lubereportstartdate: Obj.lubereportstartdate, lubereportenddate: Obj.lubereportenddate, ...props.formObj, lubereportstatus: Obj_2, })
    } else {
      setSelected(event.title)
      Obj.Totreportenddate = [getDefaultTotDate().endDate];
      Obj.Totreportstartdate = [getDefaultTotDate().startDate];
      Obj_3 = [{ id: event.title, name: event.title }]
      filterReportTot({ Totreportstartdate: Obj.Totreportstartdate, Totreportenddate: Obj.Totreportenddate, ...props.formObj, Totreportstatus: Obj_3, })
    }
  };

useEffect(() => {
  if (props.ClearProgressBar == true){
    setSelected(props.DataProgressBar)
  }
}, [props.ClearProgressBar,props.DataProgressBar]);
  useEffect(() => {
    let SelectedReports = ""
    if (reportsubType == "Fuel") {
      let ObjParse = JSON.parse(GlobalFilterSettingValue);
      if (ObjParse !== "" && ObjParse !== undefined && ObjParse) {
      SelectedReports = ObjParse.Fqtreportstatus[0] ? ObjParse.Fqtreportstatus[0].name : null
      setSelected(SelectedReports)
    }
  }
  }, [GlobalFilterSettingValue, DataName])
  useEffect(() => {
    let SelectedReports = ""
    if (reportsubType == "Tot") {
      let ObjParse_2 = JSON.parse(GlobalFilterSettingValue);
      if (ObjParse_2 !== "" && ObjParse_2 !== undefined && ObjParse_2) {
      SelectedReports = ObjParse_2.Totreportstatus[0]? ObjParse_2.Totreportstatus[0].name : null
      setSelected(SelectedReports)
    }
  }
  }, [GlobalFilterSettingValue, DataName])
  useEffect(() => {
    let SelectedReports = ""
    if (reportsubType == "Lube") {
      let ObjParse_1 = JSON.parse(GlobalFilterSettingValue);
      if (ObjParse_1 !== "" && ObjParse_1 !== undefined && ObjParse_1) {
      SelectedReports = ObjParse_1.lubereportstatus[0] ? ObjParse_1.lubereportstatus[0].name : null
      setSelected(SelectedReports)
    }
  }

  }, [GlobalFilterSettingValue, DataName])
  const defaultValue = (val) => {

    let Obj = {};
    if (val !== "" && val !== undefined && val !== "null") {
      Obj = JSON.parse(val);
      if (reportsubType == "Fuel") {
        Obj.Fqtreportenddate = [getDefaultFuelDate().endDate];
        Obj.Fqtreportstartdate = [getDefaultFuelDate().startDate];
      }

      else if (reportsubType == "Lube") {
        Obj.lubereportenddate = [getDefaultLubeDate().endDate];
        Obj.lubereportstartdate = [getDefaultLubeDate().startDate];
      }
      else {
        Obj.Totreportenddate = [getDefaultTotDate().endDate];
        Obj.Totreportstartdate = [getDefaultTotDate().startDate];
      }
    }
    else {
      if (reportsubType == "Fuel") {
        Obj.Fqtreportenddate = [getDefaultFuelDate().endDate];
        Obj.Fqtreportstartdate = [getDefaultFuelDate().startDate];
      }

      else if (reportsubType == "Lube") {
        Obj.lubereportenddate = [getDefaultLubeDate().endDate];
        Obj.lubereportstartdate = [getDefaultLubeDate().startDate];
      }
      else {
        Obj.Totreportenddate = [getDefaultTotDate().endDate];
        Obj.Totreportstartdate = [getDefaultTotDate().startDate];
      }
    }
    setfiltercomObj(Obj);
  }
  useEffect(() => {
    defaultValue(GlobalFilterSettingValue);
  }, []);


  const fetchTransformer = async () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship`;
    //const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Transformer/${customerKey}`;
    await getRequest(url)
      .then((res) => {
        console.log("Responce", res);
        if (res.status == 200) {
          // dispatch({ type: LOADING, payload: false });
          //setShipNameData(res.data);
        } else {
          //ToastError(res.data.message);
        }
      })
      .catch((error) => { });
  }

  useEffect(() => {
    fetchTransformer();
  }, []);


  return (
    <div>
      <Box
        component="main"
        bgcolor="#fff"
        p={2}
        className={classes.mainBox}
        display="flex"
      >
        <Grid container>
          <Grid item xs={12}>
            <Box component="h4" className="dashboard-sub-title" pb={0} fontSize={16} m={0}>
              <Box component="div" display="flex" alignItems="center">
                <Grid container>
                  <Grid item xs={12} sm={12} md={6}>
                    <Box component="span" pr={0.5} pt={0.5}>
                      {type == "reportstatus" ? <img src="assets/svg/Reports1.png" /> : <img src="/assets/svg/flask.svg" />}
                    </Box>
                    <Box component="span" className="titlecopy1" > {row.title}  </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box component="div" py={2}>
              <Grid container>
                <Grid item xs={12} sm={12} md={5} >
                  <Box
                    component="div"
                    display="flex"
                    pr={2}
                    justifyContent="center"
                  >
                    <Box
                      component="div"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      className={classes.roundBox}
                    >
                      <Box component="div" className="dash-left-cir">
                        <Box
                          component="h2"
                        >
                          {row.caseCount}
                        </Box>
                        <Box component="span" fontSize={14}>
                          {row.text1} {row.text2}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={7} >
                  {Object.keys(row).length
                    ? linearData.map((item) => (
                      <Box component="div" key={item.title} pb={1} pt={0.8} style={{ cursor: "pointer", padding: "5px", "box-shadow": selected == item.title && !props.clearBarSelection ? "0 0 11px" : null }} class="progressBar" onClick={() => { onChangeText(item) }}>
                        <LinearProgressBar
                          colors={item.color}
                          value={item.perValue}
                          numbers={item.value}
                          boxShadow={item.boxShadow}
                        />
                      </Box>
                    ))
                    : ""}
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box component="div" display="flex" alignItems="center">
              {Object.keys(row).length
                ? row.typeOfCase.map((item) => (

                  <Box className="dashboardkey"
                    key={item.title}
                    component="div"
                    pr={2}
                  >
                    <svg height="10" width="10">
                      <circle cx="5" cy="5" r="4" fill={item.color} />
                    </svg>
                    <Box component="span" pl={1}>
                      {item.title}
                    </Box>
                  </Box>

                ))
                : ""}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
